import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { emailConfigApi } from './api/emailConfigApi';
import { notificationApi } from './api/notificationApi';
import { organizationApi } from './api/organizationApi';
import { userApi } from './api/userApi';
import authReducer from './slices/authSlice';
import { phoneCodeApi } from './api/phoneCodeApi';
import { setStore } from './storeRef';
import { storageConfigApi } from './api/storageConfigApi';
import { environmentConfigApi } from './api/environmentConfigApi';



export const store = configureStore({
  reducer: {
    auth: authReducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [phoneCodeApi.reducerPath]: phoneCodeApi.reducer,
    [emailConfigApi.reducerPath]: emailConfigApi.reducer,
    [storageConfigApi.reducerPath]: storageConfigApi.reducer,
    [environmentConfigApi.reducerPath]: environmentConfigApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      organizationApi.middleware,
      notificationApi.middleware,
      userApi.middleware,
      phoneCodeApi.middleware,
      emailConfigApi.middleware,
      storageConfigApi.middleware,
      environmentConfigApi.middleware,
    ),
  devTools: import.meta.env.MODE !== 'production',
});

setStore(store);

// Enable refetchOnFocus and refetchOnReconnect
setupListeners(store.dispatch);

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;